var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form-read-only" },
    _vm._l(_vm.componentsList, function (component, index) {
      return _c(
        "div",
        { key: component._uuid },
        [
          _c(`${component.type}-read-only`, {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.hiddenComponent(component),
                expression: "!hiddenComponent(component)",
              },
            ],
            tag: "component",
            attrs: {
              component: component,
              components: _vm.components,
              index: index,
              value: _vm.jsonData[component.key],
            },
          }),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }